// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2a-1";
export var movingGradient = "_2a-4";
export var movingGradientBlock = "_2a-2";
export var skeleton = "_2a-0";
export var skeletonText = "_2a-3";